import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=863afa9c&scoped=true&lang=pug"
import script from "./UserSettings.js?vue&type=script&lang=js&external"
export * from "./UserSettings.js?vue&type=script&lang=js&external"
import style0 from "./UserSettings.sass?vue&type=style&index=0&id=863afa9c&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863afa9c",
  null
  
)

export default component.exports